export default "__VITE_ASSET__CMyFz9$r__"